/* Add-On Lab — config-driven add-on accordion (replaces Infinite Options).
   Sections come from addon-lab-config.js keyed by product handle; the snippet
   provides window.AddonLab = { handle, penVariants }. Products with no config
   render nothing. Live availability from /products/<handle>.js; sold-out
   variants are hidden. BUY NOW is intercepted (capture phase) and the main
   product + add-ons + engraving fee post to /cart/add.js in one call.
   Engraving text rides as line-item properties on the main item and fee line. */
(function () {
  var cfg = window.AddonLab;
  if (!cfg || !window.AddonLabConfig) return;
  var root = document.getElementById('addon-lab');
  if (!root) return;

  var sections = window.AddonLabConfig.forHandle(cfg.handle);
  if (!sections.length) { root.innerHTML = ''; return; }

  var products = {};   // url-handle -> product json (or null)
  var state = {};      // sectionIndex -> selection (product/products/choice)
  var engrave = {};    // sectionIndex -> { texts: {key: str}, orients: {key: str} }
  var open = {};       // sectionIndex -> bool

  var DEFAULT_ORIENT = 'Right-Handed';
  var ORIENTS = ['Right-Handed', 'Left-Handed'];

  sections.forEach(function (s, i) {
    if (s.type === 'engraving') {
      engrave[i] = { texts: {}, orients: {} };
      s.items.forEach(function (it) { engrave[i].orients[it.key] = DEFAULT_ORIENT; });
    }
    if (s.type === 'choice') state[i] = { option: s.options[0] };
  });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function metalKey(title) {
    return (title || '').trim().split(/[\s/]+/)[0].toLowerCase();
  }
  function penVariantId() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var input = forms[i].querySelector('[name="id"]');
      if (input && cfg.penVariants[input.value] !== undefined) return input.value;
    }
    return null;
  }
  function penMetal() {
    var id = penVariantId();
    return id ? metalKey(cfg.penVariants[id]) : null;
  }
  function imgUrl(src, size) {
    if (!src) return null;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
  }
  function variantImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (product.images && product.images.length) return product.images[0];
    return null;
  }
  function feeProduct(s) { return s.fee ? products[s.fee] : null; }
  function feePrice(s) {
    var p = feeProduct(s);
    return p ? p.variants[0].price : 0;
  }
  function engraveEngaged(i) {
    var e = engrave[i];
    if (!e) return false;
    return Object.keys(e.texts).some(function (k) { return (e.texts[k] || '').trim(); });
  }
  function anythingSelected() {
    return sections.some(function (s, i) {
      if (s.type === 'engraving') return engraveEngaged(i);
      if (s.type === 'choice') return false; // preference only; rides along, never triggers intercept alone
      return !!state[i];
    }) || sections.some(function (s, i) { return s.type === 'choice' && state[i]; });
  }

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  // ---- rendering ----------------------------------------------------------
  function headState(s, i) {
    if (s.type === 'engraving') {
      if (!engraveEngaged(i)) return '<span class="al-head-state">No thanks</span>';
      var fp = feePrice(s);
      return '<span class="al-head-state al-picked">Yes &middot; ' + (fp ? '+' + money(fp) : 'Free') + '</span>';
    }
    if (s.type === 'choice') {
      return '<span class="al-head-state al-picked">' + esc(state[i].option) + '</span>';
    }
    var sel = state[i];
    return sel
      ? '<span class="al-head-state al-picked">' + esc(sel.title) + ' &middot; +' + money(sel.price) + '</span>'
      : '<span class="al-head-state">No thanks</span>';
  }

  function tileHtml(i, vid, title, price, img, isMatch, picked) {
    return '<div class="al-tile' + (picked ? ' al-selected' : '') + '"' +
      ' data-section="' + i + '" data-variant="' + vid + '">' +
      (isMatch ? '<span class="al-badge al-badge-match">Matches your pen</span>' : '') +
      (img ? '<img class="al-tile-img" loading="lazy" src="' + imgUrl(img, 128) + '" alt="">' : '') +
      '<span class="al-tile-name">' + esc(title) + '</span>' +
      (price !== null ? '<span class="al-tile-price">+' + money(price) + '</span>' : '') +
      '</div>';
  }

  function orientHtml(i, itemKey, current) {
    return '<div class="al-orient" data-orient-row="1">' + ORIENTS.map(function (o) {
      return '<span class="al-orient-opt' + (o === current ? ' al-selected' : '') + '"' +
        ' data-osection="' + i + '" data-oitem="' + esc(itemKey) + '" data-orient="' + o + '">' + o + '</span>';
    }).join('') + '</div>';
  }

  function bodyHtml(s, i) {
    var inner = '<p class="al-section-blurb">' + s.blurb + '</p>';

    if (s.type === 'product') {
      var p = products[s.handle];
      var variants = p.variants.filter(function (v) { return v.available; });
      var sel = state[i];
      var tiles = '<div class="al-tile al-tile-none' + (sel ? '' : ' al-selected') + '" data-none="' + i + '">' +
        '<span class="al-tile-name">No thanks</span></div>';
      tiles += variants.map(function (v) {
        var isMatch = s.match && metalKey(v.title) === penMetal();
        return tileHtml(i, v.id, v.title.replace('Default Title', p.title), v.price,
          variantImage(p, v), isMatch, sel && sel.variantId === v.id);
      }).join('');
      inner += '<div class="al-tiles">' + tiles + '</div>';

    } else if (s.type === 'products') {
      var sel2 = state[i];
      var tiles2 = '<div class="al-tile al-tile-none' + (sel2 ? '' : ' al-selected') + '" data-none="' + i + '">' +
        '<span class="al-tile-name">No thanks</span></div>';
      tiles2 += s.handles.map(function (h) {
        var p2 = products[h];
        if (!p2) return '';
        var v = p2.variants.filter(function (x) { return x.available; })[0];
        if (!v) return '';
        var isMatch = s.match && metalKey(p2.title) === penMetal();
        return tileHtml(i, v.id, p2.title, v.price, variantImage(p2, v), isMatch, sel2 && sel2.variantId === v.id);
      }).join('');
      inner += '<div class="al-tiles">' + tiles2 + '</div>';

    } else if (s.type === 'engraving') {
      var e = engrave[i];
      var maxLen = s.maxLen || 30;
      inner += s.items.map(function (it) {
        var label = it.key ? it.key + ' engraving' : 'Engraving text';
        var val = e.texts[it.key] || '';
        var html = '<div class="al-engrave-item">' +
          '<input class="al-engrave-input" type="text" maxlength="' + maxLen + '"' +
          ' data-esection="' + i + '" data-eitem="' + esc(it.key) + '"' +
          ' placeholder="' + esc(label) + '" value="' + esc(val) + '">' +
          '<div class="al-engrave-count" data-count-for="' + esc(it.key) + '">' + val.length + '/' + maxLen + ' characters</div>';
        if (!s.sharedOrientation) html += orientHtml(i, it.key, e.orients[it.key]);
        return html + '</div>';
      }).join('');
      if (s.sharedOrientation) inner += orientHtml(i, s.items[0].key, e.orients[s.items[0].key]);

    } else if (s.type === 'choice') {
      var selC = state[i];
      inner += '<div class="al-tiles">' + s.options.map(function (o) {
        return '<div class="al-tile' + (selC.option === o ? ' al-selected' : '') + '"' +
          ' data-csection="' + i + '" data-choice="' + esc(o) + '">' +
          '<span class="al-tile-name">' + esc(o) + '</span></div>';
      }).join('') + '</div>';
    }
    return '<div class="al-body">' + inner + '</div>';
  }

  function sectionVisible(s) {
    if (s.type === 'product') {
      var p = products[s.handle];
      return p && p.variants.some(function (v) { return v.available; });
    }
    if (s.type === 'products') {
      return s.handles.some(function (h) {
        var p = products[h];
        return p && p.variants.some(function (v) { return v.available; });
      });
    }
    if (s.type === 'engraving') return !s.fee || !!feeProduct(s);
    return true;
  }

  function render() {
    var any = false;
    var html = sections.map(function (s, i) {
      if (!sectionVisible(s)) return '';
      any = true;
      var isOpen = !!open[i];
      return '<div class="al-section' + (isOpen ? ' al-open' : '') + '">' +
        '<div class="al-head" data-head="' + i + '">' +
        '<span class="al-head-title">' + esc(s.title) + '</span>' +
        headState(s, i) +
        '<span class="al-chev">&#9662;</span>' +
        '</div>' + (isOpen ? bodyHtml(s, i) : '') + '</div>';
    }).join('');

    root.innerHTML =
      (any ? '<h4 class="al-group-title">Optional Add-ons</h4>' +
        '<p class="al-group-blurb">The item is complete as-is &mdash; these are extras. Tap any row to explore.</p>' : '') +
      html +
      '<div class="al-summary" data-al-summary></div>' +
      '<div class="al-error" data-al-error></div>';
    updateSummary();
  }

  function updateSummary() {
    var box = root.querySelector('[data-al-summary]');
    if (!box) return;
    var lines = [], total = 0;
    sections.forEach(function (s, i) {
      if (s.type === 'engraving' && engraveEngaged(i)) {
        var fp = feePrice(s);
        total += fp;
        lines.push(['Engraving', fp ? '+' + money(fp) : 'Free']);
      } else if ((s.type === 'product' || s.type === 'products') && state[i]) {
        total += state[i].price;
        lines.push([s.title + ': ' + state[i].title, '+' + money(state[i].price)]);
      }
    });
    if (!lines.length) { box.classList.remove('al-visible'); box.innerHTML = ''; return; }
    box.innerHTML = lines.map(function (l) {
      return '<div class="al-summary-line"><span>' + esc(l[0]) + '</span><span class="al-sum-price">' + l[1] + '</span></div>';
    }).join('') +
      '<div class="al-summary-line al-summary-total"><span>Add-ons</span><span class="al-sum-price">+' +
      money(total) + '</span></div>';
    box.classList.add('al-visible');
  }

  function showError(msg) {
    var box = root.querySelector('[data-al-error]');
    if (!box) return;
    box.textContent = msg;
    box.classList.add('al-visible');
  }

  // ---- interactions -------------------------------------------------------
  root.addEventListener('click', function (e) {
    var head = e.target.closest('.al-head');
    if (head) { var hi = head.getAttribute('data-head'); open[hi] = !open[hi]; render(); return; }

    var none = e.target.closest('.al-tile-none');
    if (none) { var ni = none.getAttribute('data-none'); delete state[ni]; open[ni] = false; render(); return; }

    var orient = e.target.closest('.al-orient-opt');
    if (orient) {
      var oi = orient.getAttribute('data-osection');
      var s = sections[oi];
      var key = orient.getAttribute('data-oitem');
      if (s.sharedOrientation) {
        s.items.forEach(function (it) { engrave[oi].orients[it.key] = orient.getAttribute('data-orient'); });
      } else {
        engrave[oi].orients[key] = orient.getAttribute('data-orient');
      }
      render(); return;
    }

    var choice = e.target.closest('[data-csection]');
    if (choice) {
      var ci = choice.getAttribute('data-csection');
      state[ci] = { option: choice.getAttribute('data-choice') };
      open[ci] = false;
      render(); return;
    }

    var tile = e.target.closest('.al-tile[data-section]');
    if (tile) {
      var i = tile.getAttribute('data-section');
      var vid = parseInt(tile.getAttribute('data-variant'), 10);
      if (state[i] && state[i].variantId === vid) {
        delete state[i];
      } else {
        var sec = sections[i];
        var pool = sec.type === 'products'
          ? sec.handles.map(function (h) { return products[h]; }).filter(Boolean)
          : [products[sec.handle]];
        for (var pi = 0; pi < pool.length; pi++) {
          var v = pool[pi].variants.find(function (x) { return x.id === vid; });
          if (v) {
            state[i] = { variantId: vid, title: v.title.replace('Default Title', pool[pi].title), price: v.price };
            break;
          }
        }
        open[i] = false;
      }
      render();
    }
  });

  root.addEventListener('input', function (e) {
    if (!e.target.classList.contains('al-engrave-input')) return;
    var i = e.target.getAttribute('data-esection');
    var key = e.target.getAttribute('data-eitem');
    engrave[i].texts[key] = e.target.value;
    var maxLen = sections[i].maxLen || 30;
    var item = e.target.closest('.al-engrave-item');
    var count = item && item.querySelector('.al-engrave-count');
    if (count) count.textContent = e.target.value.length + '/' + maxLen + ' characters';
  });

  // Keep "Matches your pen" badges in sync with the variant picker.
  var lastMetal = null;
  setInterval(function () {
    var m = penMetal();
    if (m !== lastMetal) {
      lastMetal = m;
      var active = document.activeElement;
      var typing = active && active.classList && active.classList.contains('al-engrave-input');
      if (!typing) render();
    }
  }, 800);

  // ---- BUY NOW interception ----------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gf_add-to-cart, .product-form-product-template[type="submit"], form[action*="/cart/add"] [type="submit"][name="add"]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || cfg.penVariants[idInput.value] === undefined) return; // not the main product form
    if (!anythingSelected()) return;                                      // nothing chosen: native flow

    e.preventDefault();
    e.stopPropagation();

    var qtyInput = form.querySelector('[name="quantity"]');
    var mainProps = {};

    sections.forEach(function (s, i) {
      if (s.type === 'choice' && state[i]) mainProps[s.propKey] = state[i].option;
      if (s.type === 'engraving' && engraveEngaged(i)) {
        var eS = engrave[i];
        s.items.forEach(function (it) {
          var text = (eS.texts[it.key] || '').trim();
          if (!text) return;
          var tKey = it.key ? it.key + ' Engraving' : 'Engraving';
          mainProps[tKey] = text;
          if (!s.sharedOrientation) {
            mainProps[it.key ? it.key + ' Orientation' : 'Engraving Orientation'] = eS.orients[it.key];
          }
        });
        if (s.sharedOrientation) mainProps['Engraving Orientation'] = eS.orients[s.items[0].key];
      }
    });

    var items = [{
      id: parseInt(idInput.value, 10),
      quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
    }];
    if (Object.keys(mainProps).length) items[0].properties = mainProps;

    sections.forEach(function (s, i) {
      if ((s.type === 'product' || s.type === 'products') && state[i]) {
        items.push({ id: state[i].variantId, quantity: 1 });
      }
      if (s.type === 'engraving' && engraveEngaged(i) && s.fee) {
        var fp = feeProduct(s);
        var fv = fp.variants[0];
        if (fp.variants.length > 1) {
          // fee product with variants (e.g. fountain-pen-engraving R/L): match orientation
          var o = engrave[i].orients[s.items[0].key];
          var matched = fp.variants.find(function (v) { return v.title === o && v.available; });
          if (matched) fv = matched;
        }
        var feeItem = { id: fv.id, quantity: 1, properties: {} };
        for (var k in mainProps) if (k.indexOf('Engraving') > -1 || k.indexOf('Orientation') > -1) feeItem.properties[k] = mainProps[k];
        items.push(feeItem);
      }
    });

    var label = btn.querySelector('.AddToCartText') || btn;
    var orig = label.textContent;
    label.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (r.ok) { window.location.href = '/cart'; return null; }
      return r.json();
    }).then(function (err) {
      if (!err) return;
      label.textContent = orig;
      showError(err.description || err.message || 'Could not add to cart — one of the items may have just sold out.');
    }).catch(function () {
      label.textContent = orig;
      showError('Network error adding to cart. Please try again.');
    });
  }, true); // capture: runs before the theme's own handlers

  // ---- load referenced products ------------------------------------------
  var needed = {};
  sections.forEach(function (s) {
    if (s.type === 'product') needed[s.handle] = 1;
    if (s.type === 'products') s.handles.forEach(function (h) { needed[h] = 1; });
    if (s.type === 'engraving' && s.fee) needed[s.fee] = 1;
  });
  Promise.all(Object.keys(needed).map(function (h) {
    return fetch('/products/' + h + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { products[h] = p; })
      .catch(function () { products[h] = null; });
  })).then(render);
})();
